import React, { useState, useEffect } from 'react';

// Import CSS & assets
import ico_close from '../../../../assets/ico/ico_close.svg';
import ico_ignore from '../../../../assets/ico/ico_ignore_white.svg';
import ico_check from '../../../../assets/ico/ico_check_loading.svg';
import Control_Range from '../controls/Control_Range';
import * as helpers from '../../../../helpers/Other_helpers';


const filter_id = "land_area";


const Filter_land_area = ({ capacity, searchParameters, setSearchParameters, filter_Delete }) => {

    // Falter Data
    const [filterData, setFilterData] = useState(capacity?.search?.currentFilters && Object.keys(capacity.search.currentFilters).includes(filter_id) ? capacity.search.currentFilters[filter_id] : null);
    // Filter Actions
    const [isDelete, setIsDelete] = useState(false);

    // Values Actions
    const [rangeValues, setRangeValues] = useState({ min: null, max: null });
    const [rangeIncrement, setRangeIncrement] = useState(10);
    const [selectedValues, setSelectedValues] = useState({ min: null, max: null });
    const [chartData, setChartData] = useState(null);
    // SET DEFAULT VALUES
    useEffect(() => {
        console.log("SET DEFAULT VALUES OF LAND AREA", searchParameters?.filters?.land_area?.values_default);
        if (searchParameters?.filters?.land_area?.values_default) {
            setRangeValues({ min: searchParameters?.filters?.land_area?.values_default?.min, max: searchParameters?.filters?.land_area?.values_default?.max });
            setChartData(searchParameters?.filters?.land_area?.chart?.data || null);
        }
    }, [searchParameters?.filters?.land_area?.values_default?.min]);
    // SET SELECTED VALUES
    useEffect(() => {
        console.log("SET MIN VALUE OF LAND AREA", searchParameters?.filters?.land_area?.values_current);
        if (searchParameters?.filters?.land_area?.values_current) {
            setSelectedValues({ ...selectedValues, min: searchParameters?.filters?.land_area?.values_current?.min });
        }
    }, [searchParameters?.filters?.land_area?.values_current?.min]);
    useEffect(() => {
        console.log("SET MAX VALUE OF LAND AREA", searchParameters?.filters?.land_area?.values_current);
        if (searchParameters?.filters?.land_area?.values_current) {
            setSelectedValues({ ...selectedValues, max: searchParameters?.filters?.land_area?.values_current?.max });
        }
    }, [searchParameters?.filters?.land_area?.values_current?.max]);
    // UPDATE SELECTED VALUES
    const handleChange_min = (value) => {
        console.log("CHANGE MIN to", value);
        if (value !== searchParameters?.filters?.land_area?.values_current?.min) {
            // Update 
            var filters = searchParameters?.filters ? JSON.parse(JSON.stringify(searchParameters.filters)) : {};
            if (filters?.land_area?.values_current) {
                filters.land_area.values_current.min = value;
            }
            setSearchParameters({ ...searchParameters, filters: filters, map_update: ("-" + (Date.now()).toString()) });
        }
    }
    const handleChange_max = (value) => {
        console.log("CHANGE MAX to", value);
        if (value !== searchParameters?.filters?.land_area?.values_current?.max) {
            // Update 
            var filters = searchParameters?.filters ? JSON.parse(JSON.stringify(searchParameters.filters)) : {};
            if (filters?.land_area?.values_current) {
                filters.land_area.values_current.max = value;
            }
            setSearchParameters({ ...searchParameters, filters: filters, map_update: ("-" + (Date.now()).toString()) });
        }
    }


    return (
        <div id="filter__land_area" className="app__search_filter_container">
            <div className="app__search_filter_header">
                {/* <div className="app__search_filter_label">Surface de la parcelle</div> */}
                <div className="app__search_filter_label">{filterData?.label || "Titre du filtre"}</div>
                {(searchParameters?.filters && Object.keys(searchParameters.filters).includes(filter_id)) &&
                    <div className="app__search_filter_button_container">
                        {/* {(highlightedRule !== null && data.composition.nodes[0].data?.isMapVisible === true && !(rule?.isIgnored === true)) &&
                        <div className="app__sectiondata_widget_layer">
                            <img src={ico_map_layers_highlight} alt="ico_map_layers" />
                            <div className="app__map_layer_checkbox"><input className="app__map_layer_checkbox_element" type="checkbox" id={"sectiondata_switch_highlightedRule_" + rule_id} checked={highlightedRule === rule_id ? true : false} onChange={() => { highlightedRule === rule_id ? setHighlightedRule("all") : setHighlightedRule(rule_id) }} /><label className="app__map_layer_checkbox_label" htmlFor={"sectiondata_switch_highlightedRule_" + rule_id}>Toggle</label></div>
                        </div>
                    }
                    {!(data?.composition?.nodes[0]?.type === "Node_Rule_Simple_Text" || data?.composition?.nodes[0]?.type === "Node_Rule_Destinations") &&
                        <div className={`app__ruleset_title_button_container ${rule?.isIgnored === true ? "app__ruleset_title_button_container_visible" : ""}`} title="Ignorer cette règle" onClick={() => { switchIgnored() }}>
                            <img src={ico_ignore} alt="ignore" style={{ height: '14px' }} />
                        </div>
                    } */}
                        <div className="app__search_filter_button" title="Supprimer ce filtre" onClick={() => { setIsDelete(true) }}>
                            <img src={ico_close} alt="close" />
                        </div>
                    </div>
                }
            </div>
            {/* BODY */}
            <div className="app__search_filter_body_container">
                {/* DESCRIPTION */}
                <div className="app__search_filter_description">{filterData?.description || "Description du filtre"}</div>
                {/* VALEURS */}
                {(searchParameters?.filters && Object.keys(searchParameters.filters).includes(filter_id)) ?
                    <div className="app__search_filter_data_container">
                        {/* <div className="app__search_filter_data_spacer"></div> */}
                        <Control_Range filter_id={filter_id} rangeValues={rangeValues} rangeIncrement={rangeIncrement} filterFormat={searchParameters.filters[filter_id]?.format} selectedValues={selectedValues} chartData={chartData} handleChange_min={handleChange_min} handleChange_max={handleChange_max} />
                        <div className="app__search_filter_data_spacer"></div>
                        {searchParameters.filters[filter_id]?.result?.nb_land === 0 ?
                            <div className="app__search_filter_data_result">Résultat : <span style={{ backgroundColor: "#c9575770", borderRadius: "10px", padding: "0 8px 1px" }}>aucune parcelle</span> ne correspond à ce critère.</div>
                            : searchParameters.filters[filter_id]?.result?.nb_land === searchParameters?.nb_land ?
                                <div className="app__search_filter_data_result">Résultat : <span style={{ backgroundColor: "#d3d3d340", borderRadius: "10px", padding: "0 8px 1px" }}>toutes les parcelles</span> correspondent à ce critère.</div>
                                : searchParameters.filters[filter_id]?.result?.nb_land > 0 &&
                                <div className="app__search_filter_data_result">Résultat : <span style={{ backgroundColor: "#d3d3d340", borderRadius: "10px", padding: "0 8px 1px" }}>{searchParameters.filters[filter_id]?.result?.nb_land} parcelles</span> correspondent à ce critère.</div>
                        }
                    </div>
                    :
                    // LOADING
                    <div className="app__search_filter_loading_container">
                        <div className="app__admin_loading_item_circle"><img src={ico_check} alt="" /></div>
                        Chargement des données
                    </div>
                }
            </div>
            {isDelete &&
                <div className="app__search_filter_actions_container" onMouseLeave={() => { setIsDelete(true) }}>
                    <div className="app__bound_type_modify_title_big">Supprimer ce critère ?</div>
                    <div className="app__ruleset_document_deletion_container">
                        <div className="app__landsvalidation_popup_button" onClick={() => { setIsDelete(false) }}>Conserver</div>
                        <div className="app__landsvalidation_popup_button_second" onClick={() => { filter_Delete(filter_id) }}>Supprimer</div>
                    </div>
                </div>
            }
        </div>
    );
};

export default Filter_land_area;
